/* @flow */
import React from 'react';
import TitleHeader from 'components/TitleHeader.jsx';

import './styles/DepositSetupViewHeader.scss';

const DepositSetupViewHeader = React.createClass({
  propTypes: {
    title: React.PropTypes.string.isRequired,
    subtext: React.PropTypes.string.isRequired,
  },

  render() {
    return (
      <TitleHeader
        title={this.props.title}
        subtext={this.props.subtext}
        className="DepositSetupViewHeader"
      />
    );
  },
});

export default DepositSetupViewHeader;



// WEBPACK FOOTER //
// ./src/payments/components/DepositSetupViewHeader.jsx